module.exports = __webpack_public_path__ + "static/media/nimbi.d8196fc8.png";